import React from 'react'
import styled from 'styled-components'
import orderBy from 'lodash/orderBy'
import moment from 'moment'

import { FONTS } from '../../../../constants'
import { Input, SearchSelect } from '../../../input'
import { _employee_type, months } from '../../types'

export const CompanyInfoFirstCol = props => {
  const {
    emp,
    users,
    invalid,
    isEditCompany,
    handleInput,
  } = props

  const employee_type = _employee_type.find(t => t.value === emp.employee_type) || null
  const line_manager = users.find(e => e._id === emp.line_manager_id) || null
  const emp_bonus_mth = months.find(m => m.value === emp.emp_bonus_mth) || null

  return (
    <FormWrapper>
      <FormGroup>
        <LabelCol>
          <Label required>Company Email</Label>
        </LabelCol>
        <InputCol>
          <Input
            name='email'
            placeholder='Enter Email'
            invalid={ invalid['email'] }
            disabled={ !isEditCompany }
            value={ emp.email || '' }
            onChange={ e => handleInput(e.target.value, 'email') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Employee Type</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='employee_type'
            placeholder='Select Employee Type'
            value={ employee_type }
            isDisabled={ !isEditCompany }
            options={ orderBy(_employee_type, 'label', 'asc') }
            onChange={ e => handleInput(e, 'employee_type') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Line Manager</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='line_manager_id'
            placeholder='Select Line Manager'
            value={ line_manager }
            isDisabled={ !isEditCompany }
            options={ orderBy(users, 'label', 'asc').filter(u => u.value !== emp.user_id) }
            onChange={ e => handleInput(e, 'line_manager_id') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Bonus Month</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='emp_bonus_mth'
            placeholder='Select Bonus Month'
            value={ emp_bonus_mth }
            isDisabled={ !isEditCompany }
            options={ months }
            onChange={ e => handleInput(e, 'emp_bonus_mth') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Hiring Date</Label>
        </LabelCol>
        <InputCol>{ moment(emp.hiring_date).format('DD/MM/YYYY') }</InputCol>
      </FormGroup>
    </FormWrapper>
  )
}

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;

    ${p => p.required && `
      ::after {
        content: '*';
        color: red;
      }
    `}
`

const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    :nth-child(1) {
        padding-right: 6px;
    }

    :nth-last-child(1) {
        padding-left: 6px;
    }
`

const FormGroup = styled.div`
    display: flex;
    margin-bottom: 16px;
`

const LabelCol = styled.div`
    display: flex;
    flex: 1;
`

const InputCol = styled.div`
    display: flex;
    flex: 2;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/edit-pane/company-info/first-column.js